import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import HoldingImage from "../holding-image/holding-image.component";
import LazyImage from "../lazy-image/lazy-image.component";
var Image = function(_param) {
    var _i18n = _param.i18n, i18n = _i18n === void 0 ? {
        noImage: "Image Unavailable"
    } : _i18n, isLazy = _param.isLazy, _className = _param.className, className = _className === void 0 ? "" : _className, onError = _param.onError, props = _object_without_properties(_param, [
        "i18n",
        "isLazy",
        "className",
        "onError"
    ]);
    var ref = useState(false), hasError = ref[0], updateErrorState = ref[1];
    var updateError = function() {
        updateErrorState(true);
    };
    return !props.src || hasError ? /*#__PURE__*/ _jsx(HoldingImage, {
        className: className,
        text: i18n.noImage
    }) : isLazy ? /*#__PURE__*/ _jsx(LazyImage, _object_spread_props(_object_spread({}, props), {
        className: className,
        onError: onError || updateError
    })) : /*#__PURE__*/ _jsx("img", {
        className: className,
        alt: props.alt || undefined,
        role: !props.alt ? "presentation" : undefined,
        src: props.src || "",
        onError: onError || updateError,
        width: props.width || undefined,
        height: props.height || undefined
    });
};
export default Image;
